<template>
  <div class="rankMain">
    <div class="tabData">
      <div class="header">
        <span>{{ activeLabel }}用户{{ userType1 }}排行榜</span>
        <span class="userBtn" @click="changeUserType">显示{{ userType2}}排行榜</span>
      </div>
      <div class="table">
        <el-table :data="userProfitData" style="width: 100%"  height="350">
          <el-table-column prop="accountId" label="id"> </el-table-column>
          <el-table-column prop="winOrLose" label="估值"> </el-table-column>
          <!-- <el-table-column prop="address" label="地址"> </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div class="tabData">
      <div class="header">
        <span>{{ activeLabel }}交易对{{symbolType1}}排行榜</span>
        <span class="symbolBtn" @click="changeSymbolType">显示{{symbolType2}}排行榜</span>
      </div>
      <div class="table">
        <el-table :data="symbolProfitData" style="width: 100%" height="350">
            <!-- <el-table-column prop="accountId" label="id"> </el-table-column> -->
            <el-table-column prop="symbol" label="交易对"> </el-table-column>
          <el-table-column prop="winOrLose" label="估值"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: ["activeLabel",'startTime','endTime'],
  data() {
    return {
      userType1: '盈利',
      userType2: '亏损',
      symbolType1:'盈利',
      symbolType2:'亏损',
    //   typeOption:['盈利','亏损'],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  computed: {
    ...mapState('report',['userProfitData','symbolProfitData'])
  },
  methods: {
    ...mapActions('report',['getUserProfit','getSymbolProfit']),
    changeUserType(){
        if(this.userType2=='亏损'){
            this.getUserProfit({startTime:this.startTime,endTime:this.endTime,type:0})
            this.userType2='盈利'
            this.userType1= '亏损'      
            return
        }
        if(this.userType2=='盈利'){
            this.getUserProfit({startTime:this.startTime,endTime:this.endTime,type:1})
            this.userType1='盈利'
            this.userType2='亏损'
            return
        }
    },
    changeSymbolType(){
        if(this.symbolType2=='亏损'){
            this.getSymbolProfit({startTime:this.startTime,endTime:this.endTime,type:0})
            this.symbolType2='盈利'
            this.symbolType1= '亏损'
      
            return
        }
        if(this.symbolType2=='盈利'){
            this.getSymbolProfit({startTime:this.startTime,endTime:this.endTime,type:1})
            this.symbolType1='盈利'
            this.symbolType2='亏损'
        
           
            return
        }
    }
  },
  mounted () {
    this.getUserProfit({startTime:this.startTime,endTime:this.endTime,type:1})
    // this.getSymbolProfit({startTime:this.startTime,endTime:this.endTime,type:1})
  },
  watch: {
    activeLabel: {
      handler(val, oldVal) {
        console.log("change-activeLabel", val);
      },
      immediate: true,
    },
    startTime: {
      handler(val, oldVal) {
        console.log("STARTtIME", val);
        this.getUserProfit({startTime:val,endTime:this.endTime,type:1})
        this.getSymbolProfit({startTime:val,endTime:this.endTime,type:1})
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.rankMain {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.tabData {
  width: 49%;
  height: 350px;
  border: 1px solid whitesmoke;
  //   background-color: skyblue;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    height: 30px;
    align-items: center;
    border-bottom: 1px solid whitesmoke;
    .userBtn {
      color: rgb(29, 162, 239);
      cursor: pointer;
    }
    .symbolBtn {
      color: rgb(29, 162, 239);
      cursor: pointer;
    }
  }
}
</style>
